window.brandLocalStorage = "bp:brands"
window.brandSessionStorage = "bp:brand"